(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["clothing-pdp-buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(initClothingBuyButtons);
  });

  function initClothingBuyButtons(root) {
    var atcBtn = root.querySelector('[data-atc-trigger]');
    var buyNowBtn = root.querySelector('[data-buy-now]');
    if (!atcBtn) return;

    root.addEventListener('clothing-pdp:variant-change', function (e) {
      var variant = e.detail.variant;
      if (!variant) return;
      atcBtn.dataset.variantId = variant.id;
      var sticky = root.querySelector('[data-sticky-atc]');
      if (sticky) sticky.dataset.variantId = variant.id;

      [atcBtn, sticky].forEach(function (btn) {
        if (!btn) return;
        if (variant.available) {
          btn.disabled = false;
          btn.textContent = btn.textContent.trim() === 'Adding...' ? btn.textContent : 'Add to bag';
        } else {
          btn.disabled = true;
          btn.textContent = 'Sold out';
        }
      });

      if (buyNowBtn) {
        buyNowBtn.style.display = variant.available ? '' : 'none';
        buyNowBtn.href = root.dataset.cartUrl + '/' + variant.id + ':1';
      }
    });

    atcBtn.addEventListener('click', function () {
      if (atcBtn.disabled) return;
      var variantId = atcBtn.dataset.variantId;
      var originalText = atcBtn.textContent;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      window.clothingPdpAddToCartAjax(root, [{ id: variantId, quantity: 1 }]).finally(function () {
        atcBtn.disabled = false;
        atcBtn.textContent = originalText === 'Adding...' ? 'Add to bag' : originalText;
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-delivery-check"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-delivery-check]').forEach(initClothingDeliveryCheck);
  });

  function initClothingDeliveryCheck(root) {
    var input = root.querySelector('[data-pincode-input]');
    var button = root.querySelector('[data-pincode-check]');
    var result = root.querySelector('[data-pincode-result]');
    var datasetUrl = root.dataset.datasetUrl;
    if (!input || !button || !result) return;

    var savedCode = null;
    try {
      savedCode = window.localStorage.getItem('clothingPdpPincode');
    } catch (e) {}
    if (savedCode) input.value = savedCode;

    function showResult(message, state) {
      result.textContent = message;
      result.hidden = false;
      result.classList.remove('is-success', 'is-error');
      if (state) result.classList.add(state);
    }

    button.addEventListener('click', function () {
      var code = input.value.trim();
      if (!/^\d{6}$/.test(code)) {
        showResult('Please enter a valid 6-digit pincode!', 'is-error');
        return;
      }

      fetch(datasetUrl)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var found = Array.isArray(data) && data.some(function (row) {
            return String(row['Postal code']) === code;
          });
          if (found) {
            try { window.localStorage.setItem('clothingPdpPincode', code); } catch (e) {}
            showResult('✓ Arrives in 2–3 days · complimentary over ₹2,000', 'is-success');
          } else {
            showResult('Sorry, this pincode is not serviceable!', 'is-error');
          }
        })
        .catch(function () {
          showResult('Could not check serviceability right now.', 'is-error');
        });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-free-gift"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-free-gift]').forEach(initClothingFreeGift);
  });

  function initClothingFreeGift(card) {
    var root = card.closest('[data-section-type="clothing-pdp"]');
    if (!root) return;

    var mapEl = card.querySelector('[data-gift-map]');
    var giftMap = mapEl ? JSON.parse(mapEl.textContent) : {};

    function render(gift) {
      if (!gift) {
        card.style.display = 'none';
        return;
      }
      card.style.display = '';
      var title = card.querySelector('.cl-pdp-gift__product-title');
      var worth = card.querySelector('.cl-pdp-gift__worth');
      var img = card.querySelector('.cl-pdp-gift__img');
      if (title) title.textContent = gift.title;
      if (worth) worth.textContent = 'worth ' + (window.clothingPdpFormatMoney ? window.clothingPdpFormatMoney(gift.price) : gift.price);
      if (img && gift.image) img.src = gift.image;
      card.dataset.currentGiftId = gift.id;
    }

    root.addEventListener('clothing-pdp:variant-change', function (e) {
      var variant = e.detail.variant;
      if (!variant) return;
      render(giftMap[variant.id]);
    });

    var atcBtn = root.querySelector('[data-atc-trigger]');
    var giftBtn = card.querySelector('[data-free-gift-atc]');
    if (giftBtn) {
      giftBtn.addEventListener('click', function () {
        var giftId = card.dataset.currentGiftId;
        var mainVariantId = atcBtn ? atcBtn.dataset.variantId : null;
        if (!giftId || !mainVariantId) return;
        var items = [{ id: mainVariantId, quantity: 1 }, { id: giftId, quantity: 1 }];
        window.clothingPdpAddToCartAjax(root, items);
      });
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-offers"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-copy-code]');
    if (!btn) return;

    var code = btn.dataset.copyCode;
    var originalHtml = btn.innerHTML;

    function done(success) {
      btn.innerHTML = success ? code + ' <span>Copied</span>' : originalHtml;
      setTimeout(function () {
        btn.innerHTML = originalHtml;
      }, 2000);
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { done(true); }).catch(function () { done(false); });
    } else {
      var textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        done(true);
      } catch (e) {
        done(false);
      }
      document.body.removeChild(textarea);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-price"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-section-type="clothing-pdp"]').forEach(function (root) {
      root.addEventListener('clothing-pdp:variant-change', function (e) {
        var variant = e.detail.variant;
        if (!variant) return;
        root.querySelectorAll('[data-variant-price]').forEach(function (el) {
          el.textContent = window.clothingPdpFormatMoney ? window.clothingPdpFormatMoney(variant.price) : variant.price;
        });
        root.querySelectorAll('[data-variant-compare-price]').forEach(function (el) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            el.textContent = window.clothingPdpFormatMoney ? window.clothingPdpFormatMoney(variant.compare_at_price) : variant.compare_at_price;
            el.classList.remove('is-hidden');
          } else {
            el.classList.add('is-hidden');
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-usp-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-lab-test]')) {
      document.dispatchEvent(new CustomEvent('clothing-pdp:open-lab-test'));
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["clothing-pdp-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-variant-picker]').forEach(initClothingVariantPicker);
  });

  function initClothingVariantPicker(picker) {
    var root = picker.closest('[data-section-type="clothing-pdp"]');
    if (!root) return;

    var jsonEl = picker.querySelector('[data-variant-json]');
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var selected = {};

    variants.forEach(function (v) {
      v.options.forEach(function (opt, i) {
        if (!selected[i + 1]) selected[i + 1] = opt;
      });
    });

    picker.querySelectorAll('.cl-swatch.is-selected, .cl-chip.is-selected').forEach(function (el) {
      selected[el.dataset.optionPosition] = el.dataset.optionValue;
    });

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selected[i + 1] === undefined || selected[i + 1] === opt;
        });
      });
    }

    function emit(variant) {
      root.dispatchEvent(new CustomEvent('clothing-pdp:variant-change', { detail: { variant: variant } }));
    }

    picker.addEventListener('click', function (e) {
      var el = e.target.closest('.cl-swatch, .cl-chip');
      if (!el || el.classList.contains('is-soldout')) return;

      var position = el.dataset.optionPosition;
      selected[position] = el.dataset.optionValue;

      picker.querySelectorAll('[data-option-position="' + position + '"]').forEach(function (sib) {
        sib.classList.remove('is-selected');
      });
      el.classList.add('is-selected');

      var colorName = picker.querySelector('[data-color-name]');
      if (colorName && el.classList.contains('cl-swatch')) {
        colorName.textContent = '— ' + el.dataset.optionValue;
      }

      var variant = findVariant();
      if (variant) emit(variant);
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-open-size-chart-popup]')) {
        var popup = document.querySelector('[data-size-guide-popup]') || document.getElementById('SizeGuidePopup');
        if (popup) popup.classList.add('is-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
